import {ActionReducer, Action} from '@ngrx/store';

// Interfaces
import {AppState} from '../../../shared/state/interfaces/app-state';

// Actions
import {
    SELECT_PRODUCT_CATEGORY,
    SELECT_RENDER_MODE,
    SELECT_PRODUCT
} from './catalog-actions';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:SummaryPageCmp'));

export const CatalogReducer: ActionReducer<any> = (state: AppState, action: Action) => {

    // Each new pass on the reducer creates new state object
    let newState;

    switch (action.type) {

        case SELECT_PRODUCT_CATEGORY:
            // let newCurrCategId = typeof action.payload === 'string' ? action.payload : action.payload.id;
            let payload = action.payload;
            if (payload.id !== undefined) {payload = payload.id;}
            newState = Object.assign( {}, state, {currentCategoryId: payload} );
            // console.log( 'action.payload:', action.payload );
            // 'SELECT_PRODUCT_CATEGORY:', [action, newState] );
            return newState;

        case SELECT_PRODUCT:
            newState = state;
            // 'SELECT_PRODUCT:', [action, newState] );
            return newState;

        case SELECT_RENDER_MODE:
            newState = Object.assign( {}, state, {renderMode: action.payload} );
            // 'SELECT_RENDER_MODE:', [action, newState] );
            return newState;

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/state/catalog-reducer.ts